<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center"  >
  <div>
    <span class="title-header">{{ 'news-articles.search.header' | translate | titlecase }}</span>
    <a (click)="navigateToArticlesSpa()">{{ 'news-articles.search.view-news-articles-on-website' | translate | titlecase }}</a>
  </div>
  <button pButton type="button"  class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center" type="button" (click)="addDialog.open()">
    <i class="large-icon pi pi-plus"></i>
    <span>{{ 'news-articles.search.add-an-article' | translate | uppercase }}</span>
  </button>
</div>

<div class="params-container mb-20">
  <div class="search-header mb-32">{{ 'news-articles.search.search-news-articles' | translate | titlecase }}</div>
  <wl-news-articles-search-params [(searchParams)]="searchParams"></wl-news-articles-search-params>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center"  >
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'common.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>

<wl-news-articles-search-grid #searchGrid [(searchParams)]="searchParams"></wl-news-articles-search-grid>

<wl-news-article-edit-dialog (saved)="searchGrid.search()" #addDialog></wl-news-article-edit-dialog>
